import { lazy } from 'react';
const Sheet = lazy(() => import('@pages/data-preprocessing/sheet/Sheet'));
const SheetField = lazy(() => import('@pages/data-preprocessing/sheet/SheetField'));
const SheetData = lazy(() => import('@pages/data-preprocessing/sheet-data/SheetData'));
const dataPreprocessingRoute =  [
    {
        path:'/sheet',
        name: '表管理',
        component: Sheet,
    },
    {
        path: '/sheetField/:tableName',
        name: '字段管理',
        component: SheetField,
        key: '/sheetField', // 有参数的，必须传个key字段。用于匹配tabs和缓存。格式为第一个"/:"前面的所有字符
    },
    {
        path: '/sheetData',
        name: '数据管理',
        component: SheetData,
    },
]
export default dataPreprocessingRoute
